import { render } from "./ToBeAlignedDot.vue?vue&type=template&id=343ed519&scoped=true"
import script from "./ToBeAlignedDot.vue?vue&type=script&lang=js"
export * from "./ToBeAlignedDot.vue?vue&type=script&lang=js"

import "./ToBeAlignedDot.vue?vue&type=style&index=0&id=343ed519&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343ed519"]])

export default __exports__